// extracted by mini-css-extract-plugin
export default {"type-default":"zG5HBnt0TLchLwzbabYW","type-larger":"u8MOs8dPK8swdIA8h31x","logo-lone":"BbiSvKsVJwvedeYSS9jO","common_bganimation":"GLH8MrKdcC5KgA3oGO4E"};